import { useEffect, useState } from "react";
import { Logo } from "../components/Logo";
import { Footer } from "../components/Footer";
import { Login } from "./Login";
import { api, fmtTL, SITE_HOST, type PublicPricing } from "../api";

export function Landing({
  initialMode,
  onLogin,
}: {
  initialMode: "sms" | "login" | "signup";
  onLogin: (me: { id: string; email: string }) => void;
}) {
  const [pricing, setPricing] = useState<PublicPricing | null>(null);

  useEffect(() => {
    api
      .getPricing()
      .then(setPricing)
      .catch(() => setPricing(null));
  }, []);

  return (
    <div className="landing">
      <header className="landing-top">
        <a className="landing-brand" href={`https://${SITE_HOST}`}>
          <Logo size={30} withDot title={SITE_HOST} />
          <span>{SITE_HOST}</span>
        </a>
      </header>

      <main className="landing-hero">
        <div className="landing-copy">
          <span className="landing-badge">SMS ile şifresiz giriş</span>
          <h1>
            Telefon numarasını <span className="accent">SMS</span> ile doğrula,
            parolaya veda et.
          </h1>
          <p className="landing-sub">
            Kullanıcılarınız ekranda gördükleri kodu kısa numaramıza SMS olarak
            gönderir; biz numarayı doğrular ve uygulamanıza imzalı bir bildirim
            göndeririz. OTP yazdırmadan, parola tutmadan güvenli giriş.
          </p>
          <p className="landing-pitch">
            <strong>Şifresiz giriş, aynı güvenlik seviyesi</strong> — daha az
            kağıt işi, çok daha uygun fiyat.
          </p>
          <p className="landing-pitch">
            <strong>Dışarıya SMS göndermediğimiz için throttle darboğazı yok</strong> —
            istediğiniz hızda, istediğiniz kadar müşteriyi daha hızlı doğrulayıp kayıt
            altına alın.
          </p>
          <p className="landing-note">
            İlk <strong>250 başarılı doğrulama</strong> ücretsiz — kredi kartı
            gerekmez. Sonrasında ihtiyacınız kadar kredi alırsınız; her başarılı
            doğrulama yalnızca <strong>1 kredi</strong> harcar.
          </p>

          <ul className="landing-points">
            <li>
              <strong>SMS ile giriş</strong> — kayıtlı telefonunuzdan tek
              kullanımlık kod göndererek parolasız, hızlıca girin.
            </li>
            <li>
              <strong>Parola ile giriş</strong> — dilerseniz e-posta ve
              parolanızla klasik girişi kullanın.
            </li>
            <li>
              <strong>Kayıt ol</strong> — saniyeler içinde ücretsiz hesap açın.
            </li>
            <li>
              <strong>Darboğazsız ölçeklenir</strong> — giden SMS kotası ve gönderim
              throttle’ı yok; aynı anda istediğiniz kadar kullanıcıyı doğrulayın.
            </li>
          </ul>
        </div>

        <div className="landing-form">
          <Login initialMode={initialMode} onLogin={onLogin} />
        </div>
      </main>

      <section className="landing-steps">
        <div className="landing-step">
          <span className="landing-step-no">1</span>
          <h3>Kaydolun</h3>
          <p>Ücretsiz hesap açın ve ilk uygulamanızı oluşturun. API anahtarınız anında hazır.</p>
        </div>
        <div className="landing-step">
          <span className="landing-step-no">2</span>
          <h3>Entegre edin</h3>
          <p>Backend’iniz tek bir uç noktayı çağırır; kullanıcıya gösterilecek kodu döneriz.</p>
        </div>
        <div className="landing-step">
          <span className="landing-step-no">3</span>
          <h3>Doğrulayın</h3>
          <p>Kullanıcı SMS gönderir, biz numarayı doğrular ve sonucu imzalı olarak iletiriz.</p>
        </div>
      </section>

      {pricing && pricing.packages.length > 0 && (
        <section className="landing-pricing">
          <h2>Kredi paketleri</h2>
          <p className="landing-pricing-sub">
            Abonelik yok, gizli ücret yok. Kredi başı{" "}
            <strong>{fmtTL(pricing.price_per_credit_kurus)}</strong> (KDV hariç); aşağıdaki
            tutarlara KDV dahildir ve her başarılı doğrulama 1 kredidir.
          </p>
          <div className="landing-pricing-grid">
            {pricing.packages.map((p) => (
              <div className="landing-price-card" key={p.id}>
                <div className="landing-price-credits">
                  {p.credits.toLocaleString("tr-TR")}
                  <span> kredi</span>
                </div>
                <div className="landing-price-amount">{fmtTL(p.gross_kurus)}</div>
                <div className="landing-price-vat">KDV dahil</div>
              </div>
            ))}
          </div>
        </section>
      )}

      <Footer />
    </div>
  );
}
